import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injector, Injectable } from '@angular/core';
import { HeaderOverridesService } from '@finder/shared/services/header-overrides/header-overrides.service';

@Injectable()
export class HeaderOverrideInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) {}

    /**
     * Add any override headers to the request
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headerOverrideSvc = this.injector.get(HeaderOverridesService);
        const headers = {};

        // Filter out just the active headers
        const activeHeaders = headerOverrideSvc.getHeaders().filter(header => header.enabled);

        // If there are no headers to add stop
        if (activeHeaders.length === 0) {
            return next.handle(req);
        }

        // Add the headers to the request
        activeHeaders.forEach(header => {
            headers[header.header] = header.value;
        });

        // Add headers to the request
        req = req.clone({
            setHeaders: headers
        });

        return next.handle(req);
    }
}
